import variant from "./variants";
import typography from "./typography";
import breakpoints from "./breakpoints";
import props from "./props";
import shadows from "./shadows";
import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme(
    {
        spacing: 4,
        breakpoints: breakpoints,
        props: props,
        typography: typography,
        shadows: shadows,
        palette: variant.palette,
    },
    {
        name: variant.name,
        body: variant.body,
        header: variant.header,
        sidebar: variant.sidebar,
    }
);

export default theme;
